import {
  Button,
  Paper,
  Grid,
  TextField,
  Select,
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Typography,
  Tab,
  Tabs,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import * as React from "react";
import { observable, action, computed, toJS, autorun, keys } from "mobx";
import { createStyles, withStyles } from "@material-ui/core/styles";
import { config } from "../../../../../../src/config";

import { authStore } from "../../../../../../src/modules/auth";
import { usersAdminStore } from "..";
import { observer } from "mobx-react";
import { companiesAdminStore } from "../../../../../../src/modules/admin/modules/CompaniesAdmin";
import { Loading } from "../../../../../../src/components/loading";
import { history } from "../../../../../../src/history.js";
import { withRouter } from "react-router";
import { AdminToolBar } from "../../../../../../src/modules/admin/components";
import { UsersForm } from "./";
import { UsersRoles } from "./";
import { validationsStore } from "../../../../validations";
import { permissionsStore } from "../../Permissions";

interface ICurrentUser {
  auth_id?: number;
  DeletedAt?: string;
  Email: string;
  FirstName: string;
  LastName: string;
  Image: string;
  Phone: string;
  Verification: string;
  Verified: number;
  materialSelectCompanyIDs: number[];
  Apps?: any[];
  Companies: any[];
}

const styles = createStyles({
  root: {
    width: "100%",
    height: "100%",
    margin: "0 auto",
    // padding: "1.5rem",
    display: "flex",
    flexDirection: "column",
  },
  rowContainer: {
    width: "100%",
    display: "flex",
    alignContent: "center",
    margin: "0 auto",
    // padding: "3rem",
  },
  columnContainer: {
    width: "100%",
    display: "flex",
    margin: "0 auto",
    // padding: "3rem",
  },
  textField: {
    display: "flex",
    paddingRight: "24px",
  },
  roleSelect: {
    minWidth: "9rem",
  },
  companySelect: {
    minWidth: "16.5rem",
  },
  appRoleSelect: {
    minWidth: "16.5rem",
    paddingTop: "1.5rem",
  },
  formContainer: {
    width: "100%",
    padding: "1.5rem",
  },
  submitContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row-reverse",
  },
  submitButton: {
    // backgroundColor: "#2A2A55",
    // border: "1px solid #2D4D73",
    // color: "#FAFAFA",
  },
  tabRoot: {},
  tabsRoot: {},
  flexContainer: {
    height: "100%",
  },
});

@observer
class UsersAdminDetails extends React.Component<any> {
  public state = { current_tab: 0, deleteDialogOpen: false };

  @observable
  public loaded_user: any;

  @observable
  public filteredPortalRoles: any; //D-011

  @observable
  public loaded: boolean = false;

  @observable
  protected validations = {
    FirstName: {
      validateFunctions: [
        {
          functionName: "regexTest",
          regexParam: /^\s*(?:[\w\.]\s*){2,50}$/,
          errorMessage: "First Name must be more than 2 characters",
          active: true,
        },
      ],
      valid: this.props.match.params.view_type !== "create",
      errorMessage: [""],
    },
    LastName: {
      validateFunctions: [
        {
          functionName: "regexTest",
          regexParam: /^\s*(?:[\w\.]\s*){2,50}$/,
          errorMessage: "Last Name must be more than 2 characters",
          active: true,
        },
      ],
      valid: this.props.match.params.view_type !== "create",
      errorMessage: [""],
    },
    Email: {
      validateFunctions: [
        {
          functionName: "regexTest",
          regexParam: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          errorMessage: "Must enter a valid Email",
          active: true,
        },
        {
          functionName: "emailUnique",
          auth_id: this.props.match.params.auth_id,
          errorMessage: "Email must be unique",
          active: true,
        },
      ],
      valid: this.props.match.params.view_type !== "create",
      errorMessage: [
        "First name must be more than 2 characters",
        "Email must be unique",
      ],
    },
    Phone: {
      validateFunctions: [
        {
          functionName: "regexTest",
          regexParam: /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/,
          errorMessage: "Must be a valid Phone Number",
          active: true,
        },
      ],
      valid: this.props.match.params.view_type !== "create",
      errorMessage: ["Must be a valid Phone Number"],
    },
    materialSelectCompanyIDs: {
      validateFunctions: [
        {
          functionName: "arrayNotEmpty",
          errorMessage: "Please Select a Company",
          active: true,
        },
      ],
      valid: this.props.match.params.view_type !== "create",
      errorMessage: ["Please select a company"],
    },
    materialSelectSiteIDs: {
      validateFunctions: [
        {
          functionName: "siteSelect",
          active: false,
          errorMessage: "Please Select a Pharmacy",
        },
      ],
      valid: true,
      errorMessage: ["Please Select a Site"],
    },
    //D-011
    materialSelectDistributorIDs: {
      validateFunctions: [
        { functionName: 'arrayNotEmpty', active: false, errorMessage: 'Please Select a Distributor' }
      ],
      valid: true,
      errorMessage: ['Please Select a Distributor']
    }, //D-011
    pharmacyRole: {
      validateFunctions: [
        {
          functionName: "arrayNotEmpty",
          active: false,
          errorMessage: "Please Select a Pharmacy Role",
        },
      ],
      valid: true,
      errorMessage: ["Please Select a Pharmacy Role"],
    },
    portal_role_id: {
      validateFunctions: [
        {
          functionName: "arrayNotEmpty",
          active: false,
          errorMessage: "Please Select a Portal Role",
        },
      ],
      valid: this.props.match.params.view_type !== "create",
      errorMessage: ["Please Select a Portal Role"],
    },
    universityRole: {
      validateFunctions: [
        {
          functionName: "arrayNotEmpty",
          active: false,
          errorMessage: "Please Select a University Role",
        },
      ],
      valid: true,
      errorMessage: ["Please Select a University Role"],
    },
  };

  constructor(props: any) {
    super(props);
    validationsStore.resetValidator();
  }

  @action
  public loadUser = async () => {
    await companiesAdminStore.getSitesList();
    await companiesAdminStore.getDistributorList(); //D-011
    if (this.props.match.params.view_type === 'create' && !this.loaded) {
      usersAdminStore.setBlankUser()
      this.loaded_user = usersAdminStore.current_user;

    }
    else {
      await usersAdminStore.getAuthByID(this.props.match.params.id);
       this.loaded_user = await {
        ...usersAdminStore.current_user,
        materialSelectCompanyIDs: usersAdminStore?.current_user?.Companies?.map((c: any) => c.company_id),
        materialSelectSiteIDs: usersAdminStore?.current_user?.Sites.map((s: any) => s.siteId),
        materialSelectDistributorIDs: usersAdminStore?.current_user?.distributor[0]?.distributorId //D-011
      }
    }
  }

  public componentDidMount = async () => {
    await this.loadUser();
    if (Object.entries(validationsStore.validator).length === 0) {
      validationsStore.startValidator(this.validations);
    }
    // if (!companiesAdminStore.loaded) {
    await companiesAdminStore.retrieveCompanies();
    // }
    const curUser = authStore.currentUser;
    let canView = true;
    console.log(this.loaded_user)
    if (this.props.match.params.view_type !== "create") {
      canView = permissionsStore.checkContentPermissions(
        curUser.portal_role_id,
        curUser.Companies,
        curUser.Sites,
        this.loaded_user.portal_role_id,
        await this.loaded_user.Companies.map((c: any) => c.company_id),
        await this.loaded_user.Sites.map((s: any) => s.siteId)
      );
    }

    // So you cant delete site and save on first load edit
    const p = this.loaded_user.Apps.find(
      (a: any) => a.app_id === 1 && a.Active
    );
    if (p && this.props.match.params.view_type === "edit") {
      validationsStore.validator[
        "materialSelectSiteIDs"
      ].validateFunctions[0].active = true;
    }

    if (!canView) {
      this.props.history.push("/admin/users");
    }

    /**
     * D-011 2.0 For Company Admin, Pharmacy User, User -> can't able to see distributor users in pharmacy portal roles "authStore.currentUser.portal_role_id"
    */
        let allRolesFiltered = usersAdminStore.all_available_roles;
        if(authStore.currentUser.portal_role_id == 4 || authStore.currentUser.portal_role_id == 5 || authStore.currentUser.portal_role_id == 6) {
            allRolesFiltered.map((item)=>{
            if(item.app_id === 1){
              item.AppRoles = item.AppRoles.filter((roles)=> (roles.pharmacy_role_id != 10 && roles.pharmacy_role_id != 11 && roles.pharmacy_role_id != 12) )
            }
          })
        }
        this.filteredPortalRoles = allRolesFiltered;
  };

  public handleChangeTab = (event: any, value: number) => {
    this.setState({
      ...this.state,
      current_tab: value,
    });
  };
  // TODO B-004 confirm disble and enable
  public getDeleteDialog = (active: boolean, user: any) => {
    return (
      <Dialog
        open={active}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        // tslint:disable-next-line: jsx-no-lambda
        onBackdropClick={() => this.setState({ deleteDialogOpen: false })}
      >
        <DialogTitle>
           {!this.loaded_user?.PortalDeletedAt ? "Confirm Disable" : "Confirm Enable"}
            {" "}{usersAdminStore.current_user.FirstName +
            " " +
            usersAdminStore.current_user.LastName}
          ?
        </DialogTitle>
        {/* <DialogTitle>
          Confirm Enable{" "}
          {usersAdminStore.current_user.FirstName +
            " " +
            usersAdminStore.current_user.LastName}
          ?
        </DialogTitle> */}
        <DialogContent />
        <DialogActions>
          {!this.loaded_user?.PortalDeletedAt ? (
            <Button
              variant="contained"
              classes={{ root: this.props.classes.submitButton }}
              // tslint:disable-next-line: jsx-no-lambda
              onClick={() => this.delete()}
              color="primary"
            >
            Disable

            </Button>
          ) : (
            <Button
              variant="contained"
              classes={{ root: this.props.classes.submitButton }}
              // tslint:disable-next-line: jsx-no-lambda
              onClick={() => this.enableUser()}
              color="primary"
            >
              Enable
            </Button>
          )}

          <Button
            variant="contained"
            classes={{ root: this.props.classes.submitButton }}
            // tslint:disable-next-line: jsx-no-lambda
            onClick={() => this.setState({ deleteDialogOpen: false })}
            color="primary"
            autoFocus={true}
          >
            Go Back
          </Button>
        </DialogActions>
      </Dialog>
    );
  };


  public getPageContent = (current_tab: number) => {
    switch (current_tab) {
      case 0: {
        return (
          <UsersForm
            currentUser={this.loaded_user}
            auth={authStore}
            view_type={this.props.match.params.view_type}
          />
        );
      }
      case 1: {
        return (
          <UsersRoles
            currentUser={this.loaded_user}
            allRoles={this.filteredPortalRoles}
            view_type={this.props.match.params.view_type}
          />
        );
      }
      default: {
        return <div>no tab found</div>;
      }
    }
  };

  public roleValidationError = () => {
    let validationError = false;
    const errorStrings = ["universityRole", "pharmacyRole"];
    Object.keys(validationsStore.validator).map((key: string) => {
      if (
        !validationsStore.validator[key].valid &&
        errorStrings.includes(key)
      ) {
        validationError = true;
        return true;
      }
      return false;
    });
    return validationError;
  };

  public getSubmitTooltipInfo = () => {
    const content = Object.keys(validationsStore.validator).map(
      (key, index) => {
        if (!validationsStore.validator[key].valid) {
          return (
            <div key={index}>
              {
                validationsStore.validator[key].validateFunctions[0]
                  .errorMessage
              }
            </div>
          );
        } else {
          return null;
        }
      }
    );
    return content;
  };

  public render() {
    const { classes, mode } = this.props;
    const deleteDialog = this.getDeleteDialog(
      this.state.deleteDialogOpen,
      this.loaded_user
    );
    const getTabs = () => {
      const roleError = this.roleValidationError();
      return (
        <Tabs
          value={this.state.current_tab}
          // tslint:disable-next-line: jsx-no-lambda
          onChange={this.handleChangeTab}
          indicatorColor="secondary"
          textColor="secondary"
          classes={{
            root: classes.tabsRoot,
            flexContainer: classes.flexContainer,
          }}
          style={{ height: "100%" }}
          // scrollable={true}
        >
          <Tab
            classes={{
              root: classes.tabRoot,
            }}
            style={{
              textTransform: "none", fontSize: '18px'
            }}
            label="Details"
          />
          <Tab
            classes={{
              root: classes.tabRoot,
            }}
            style={{
              backgroundColor: roleError ? "rgba(255, 0, 0, 0.4)" : "white", textTransform: "none", fontSize: '18px'
            }}
            label="Roles"
          />
        </Tabs>
      );
    };

    const page_content = this.getPageContent(this.state.current_tab);

    if (
      !usersAdminStore.loaded ||
      !companiesAdminStore.loaded ||
      !validationsStore.loaded ||
      !!!this.loaded_user
    ) {
      return <Loading />;
    } else {
      return (
        <div className={classes.root}>
          {deleteDialog}
          <AdminToolBar pageTitle={"User Detail"} tabs={getTabs()} />
          {page_content}
          <Grid item={true} xs={6}>
            <div
              className={classes.submitContainer}
              style={{
                display:
                  this.props.match.params.view_type === "detail" ? "none" : "",
              }}
            >
              <Tooltip
                title={this.getSubmitTooltipInfo()}
                disableHoverListener={!this.submitDisabled()}
              >
                <div>
                  <Button
                    classes={{ root: classes.submitButton }}
                    onClick={this.submit}
                    disabled={this.submitDisabled()}
                    variant="contained"
                  >
                    Submit
                  </Button>
                </div>
              </Tooltip>
              {permissionsStore.checkPermissionByCategoryAndType(
                      "user",
                      "delete"
                    ) && (!this.loaded_user?.PortalDeletedAt ? (
                <Button
                  classes={{ root: classes.submitButton }}
                  disabled={this.props.match.params.view_type !== "edit"}
                  // tslint:disable-next-line: jsx-no-lambda
                  onClick={() => this.setState({ deleteDialogOpen: true })}
                  variant="contained"
                  // disabled={
                  //   !permissionsStore.checkPermissionByCategoryAndType(
                  //     "user",
                  //     "delete"
                  //   )
                  // }

                >
                  Disable
                </Button>
              ) : (
                <Button
                  classes={{ root: classes.submitButton }}
                  disabled={this.props.match.params.view_type !== "edit"}
                  // tslint:disable-next-line: jsx-no-lambda
                  onClick={() => this.setState({ deleteDialogOpen: true })}
                  variant="contained"
                  // disabled={
                  //   !permissionsStore.checkPermissionByCategoryAndType(
                  //     "user",
                  //     "delete"
                  //   )
                  // }

                >
                  Enable
                </Button>
              ))}
              {/* <Button
                classes={{ root: classes.submitButton }}
                // onClick={this.submit}
                // disabled={this.submitDisabled()}
                variant='contained'
              >
                Deactivate
              </Button> */}
            </div>
          </Grid>
        </div>
      );
    }
  }
  @action
  protected submitDisabled = () => {
    for (const key in validationsStore.validator) {
      if (validationsStore.validator.hasOwnProperty(key)) {
        if (!validationsStore.validator[key].valid) {
          return true;
        }
      }
    }
    return false;
  };

  @action
  protected submit = async () => {
    await usersAdminStore.saveUser(this.loaded_user);
    return this.props.history.push("/admin/users");
  };

  @action
  protected delete = async () => {
    await usersAdminStore.deleteUser(this.loaded_user);
    return this.props.history.push("/admin/users");
  };
  @action
  protected enableUser = async () => {
    await usersAdminStore.enableUser(this.loaded_user);
    return this.props.history.push("/admin/users");
  };

  //#TODO Deactivate function for here
  // @action
  // protected Deactivate = async () => {
  //   await usersAdminStore.DeactivateUser(this.loaded_user);
  //   return this.props.history.push('/admin/users');
  // };
}

export default withStyles(styles, { withTheme: true })(
  withRouter(UsersAdminDetails)
);



// WEBPACK FOOTER //
// ./src/modules/admin/modules/UsersAdmin/components/UsersAdminDetails.tsx